<a class="nav-item nav-link" type="button">
  <morva-icons [matMenuTriggerFor]="help" icon="helpCircle" nbTooltip="راهنما"
    nbTooltipPlacement="bottom"></morva-icons>
</a>
<mat-menu #help="matMenu" class="help-card">
  <nb-card [size]="'medium'">
    <nb-card-body>
      <nb-list>
        <nb-list-item>
          <div class="d-flex flex-column">
            <a class="link p-1 my-1" [href]="guideURL"> دانلود راهنما </a>
          </div>
        </nb-list-item>
      </nb-list>
    </nb-card-body>
  </nb-card>
</mat-menu>
